import { useState } from "react";
import { Button, Dialog, Modal, ModalOverlay } from "react-aria-components";
import { ChevronDown } from "lucide-react";

import { MerryButton } from "@/shared/ui/MerryButton";
import { MerrySelectOptions } from "@/shared/ui/components/MerrySelectOptions";

const MARKET_OPTIONS = [
  { id: "US", label: "美国" },
  { id: "GB", label: "英国" },
  { id: "DE", label: "德国" },
  { id: "FR", label: "法国" },
  { id: "CA", label: "加拿大" },
  { id: "AU", label: "澳大利亚" },
  { id: "JP", label: "日本" },
  { id: "SG", label: "新加坡" },
  { id: "MY", label: "马来西亚" },
  { id: "ID", label: "印度尼西亚" },
] as const;

interface MerchantHomeMarketDialogProps {
  market: string;
  category: string;
  onChange: (market: string, category: string) => void;
  onClose: () => void;
}

export function MerchantHomeMarketDialog({ market, category, onChange, onClose }: MerchantHomeMarketDialogProps) {
  const [selectedMarket, setSelectedMarket] = useState(market);
  const options = MARKET_OPTIONS.some((option) => option.id === market) || !market
    ? MARKET_OPTIONS
    : [...MARKET_OPTIONS, { id: market, label: market }];
  const selectedLabel = options.find((option) => option.id === selectedMarket)?.label;

  return (
    <ModalOverlay isOpen isDismissable onOpenChange={(open) => { if (!open) onClose(); }} className="merchant-home-market-overlay">
      <Modal className="merchant-home-help merchant-home-market-dialog">
        <Dialog aria-label="商机目标">
          <form
            className="merchant-home-market-form"
            onSubmit={(event) => {
              event.preventDefault();
              const fields = new FormData(event.currentTarget);
              onChange(String(fields.get("market") ?? ""), String(fields.get("category") ?? "").trim());
            }}
          >
            <h3>商机目标</h3>
            <p>补充目标后查看对应的商机资料。</p>
            <div className="merchant-home-market-field">
              <span>目标市场</span>
              <MerrySelectOptions
                ariaLabel="目标市场"
                className="merchant-home-market-select"
                isRequired
                name="market"
                onChange={setSelectedMarket}
                options={options}
                popoverClassName="merchant-home-market-select__popover"
                selectedId={selectedMarket}
              >
                <Button className="merchant-home-market-select__trigger">
                  <span className={selectedLabel ? undefined : "merchant-home-market-select__placeholder"}>
                    {selectedLabel ?? "请选择市场"}
                  </span>
                  <ChevronDown aria-hidden="true" size={16} />
                </Button>
              </MerrySelectOptions>
            </div>
            <label>商品品类<input name="category" defaultValue={category} maxLength={120} placeholder="例如：咖啡用品" required /></label>
            <div className="merchant-home-market-actions">
              <MerryButton hierarchy="level1" onPress={onClose}>取消</MerryButton>
              <MerryButton type="submit" hierarchy="level3">应用目标</MerryButton>
            </div>
          </form>
        </Dialog>
      </Modal>
    </ModalOverlay>
  );
}
